module.exports = __webpack_public_path__ + "static/scale-model-of-edith-macefield-house-in-seattle-washington-0a103b9511d26fb77b924c009e1f16ef.png";